// Components & Data Imports
import Prihlaska26 from '../resources/docs/Prihlaska2026.pdf'

// Icons
import { FaCampground } from 'react-icons/fa'
import {
  BsCalendar2WeekFill,
  BsPinMapFill,
  BsFillPeopleFill,
  BsCash,
  BsFiletypePdf,
} from 'react-icons/bs'

const Event = () => {
  return (
    <>
      <section className='event-container' id='event'>
        <div className='event-heading'>
          <FaCampground className='event-heading-icon' />
          <div className='event-heading-title'>Ročník 2026</div>
          <div className='event-heading-subtitle'>Letní návrat k Sázavě</div>
        </div>
        <div className='event-box'>
          <div className='event-box-left'>
            <div className='event-box-left-item'>
              <BsCalendar2WeekFill className='event-box-left-item-icon' />
              <div className='event-box-left-item-value'>15.8. - 29.8.2026</div>
            </div>
            <div className='event-box-left-item'>
              <BsPinMapFill className='event-box-left-item-icon' />
              <div className='event-box-left-item-value'>Český Šternberk</div>
            </div>
            <div className='event-box-left-item'>
              <BsFillPeopleFill className='event-box-left-item-icon' />
              <div className='event-box-left-item-value'>Věk 6-15 let</div>
            </div>
            <div className='event-box-left-item'>
              <BsCash className='event-box-left-item-icon' />
              <div className='event-box-left-item-value'>6 500 Kč</div>
            </div>
          </div>
          <div className='event-box-right'>
            <div className='event-box-right-info'>
              <span>Informace o táboře</span>
              <br />
              <p>
                Srdečně Vás zveme na letošní ročník našeho tábora. O děti se
                stará tým zkušených vedoucích a aktivních praktikantů, z nichž
                mnozí sami na našem táboře vyrostli a dodnes ho vnímají jako
                svoji srdeční záležitost.
              </p>
              <p>
                Ubytování je zajištěno ve větších chatkách po šesti a v menších
                chatkách po dvou osobách. Stravování probíhá 5× denně a
                dodržování pitného režimu hlídame po celý den.
              </p>
              <p>
                {' '}
                V areálu se nachází prosklená jídelna, společenské místnosti,
                táborové ohniště, travnaté hřiště a velký kruhový bazén. Děti se
                mohou těšit na koupání, táboráky, diskotéky, výlety a další
                pestrý program.{' '}
              </p>
              <p>
                Autobusová doprava na tábor i zpět je zajištěna pro všechny
                účastníky. Rodiče, kteří plánují dopravu dítěte individuálně,
                prosíme, aby nám tuto informaci sdělili na e-mail:
                info@hlavas.org
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className='event-container-2'>
        <div className='event-container-2-parents'>
          <div className='event-container-2-parents-info'>
            <span>Pro rodiče</span>
            <br />
            <p>
              Zálohu ve výši 1 000 Kč prosíme uhraďte nejpozději do{' '}
              <b>30.4.2026,</b> zbytek částky pak nejpozději do <b>30.6.2026</b>{' '}
              na číslo účtu <b>123-3451350257/0100,</b> do zprávy pro příjemce
              uveďte jméno a příjmení dítěte.
            </p>
            <p>
              Prosíme rodiče, pokud by měli požadavky na{' '}
              <b>společné bydlení dětí s jejich kamarády v jedné chatce,</b>{' '}
              případně zařazení do stejného oddílu, aby nám tyto informace
              sdělili nejpozději do <b>30.6.2026</b> na náš táborový email{' '}
              <b>info@hlavas.org.</b> Vzhledem k malému počtu velkých chatiček
              prosíme, aby požadavky k ubytování byly pouze po dvojicích.
              Děkujeme.
            </p>
          </div>
          <div className='event-container-2-parents-title'>
            Dokumenty ke stažení
          </div>
          <div className='event-container-2-parents-docs'>
            <div className='event-container-2-parents-docs-item'>
              <BsFiletypePdf className='event-container-2-parents-docs-item-icon' />
              <a
                href={Prihlaska26}
                className='event-container-2-parents-docs-item-text'
                target='blank'
              >
                Přihláška 2026
              </a>
            </div>
            <div className='event-container-2-parents-docs-item event-container-2-parents-docs-item-disabled'>
              <BsFiletypePdf className='event-container-2-parents-docs-item-icon' />
              <div className='event-container-2-parents-docs-item-text'>
                Seznam věcí
              </div>
            </div>
            <div className='event-container-2-parents-docs-item event-container-2-parents-docs-item-disabled'>
              <BsFiletypePdf className='event-container-2-parents-docs-item-icon' />
              <div className='event-container-2-parents-docs-item-text'>
                Posudek zdravotní způsobilosti
              </div>
            </div>
            <div className='event-container-2-parents-docs-item event-container-2-parents-docs-item-disabled'>
              <BsFiletypePdf className='event-container-2-parents-docs-item-icon' />
              <div className='event-container-2-parents-docs-item-text'>
                Prohlášení rodičů o bezinfekčnosti
              </div>
            </div>
            <div className='event-container-2-parents-docs-item event-container-2-parents-docs-item-disabled'>
              <BsFiletypePdf className='event-container-2-parents-docs-item-icon' />
              <div className='event-container-2-parents-docs-item-text'>
                Prohlášení zákonných zástupců GDPR
              </div>
            </div>
            <div className='event-container-2-parents-docs-item event-container-2-parents-docs-item-disabled'>
              <BsFiletypePdf className='event-container-2-parents-docs-item-icon' />
              <div className='event-container-2-parents-docs-item-text'>
                Souhlas s poskytováním informací o zdravotním stavu
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Event
